$(function () {

    /** Append main menu toggle button */
    $('.site_header__mid_section__left_side').append('<button class="nav_toggle" aria-label="Toggle main navigation menu"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg></button>');

    /** Append subnav toggle button */
    $('.site_header .menu-item-has-children').append("<button class='submenu_toggle' aria-label='Toggle sub-navigation'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='24' height='24' viewBox='0 0 24 24'><path d='M7,10L12,15L17,10H7Z' /></svg></button>");

    /** Declare variables */
    var nav = $('.site_header__bottom_section__navigation');
    var navToggle = $('.site_header .nav_toggle');
    var subMenu = $('.sub-menu');

    /** Add/remove classess when JS is enabled */
    nav.addClass('site_header__bottom_section__navigation--hidden');
    nav.addClass('site_header__bottom_section__navigation--js-ready');
    subMenu.addClass('sub-menu--hidden');

    /** Nav toggle functionality */
    navToggle.on('click', function () {

        nav.toggleClass('site_header__bottom_section__navigation--hidden');

    });

    /** Subnav toggle functionality */
    $('.submenu_toggle').each(function (e) {

        $(this).on('click', function (e) {

            e.stopPropagation();

            var submenu = $(this).prev('.sub-menu');

            /**
             * Remove active states from all menu toggle buttons except the current one
             */
            $(this).toggleClass('submenu_toggle--active');
            $('.submenu_toggle').not($(this)).removeClass('submenu_toggle--active');

            /**
             * Hide all submenus except for the current one
             */
            $('.sub-menu').not(submenu).removeClass('sub-menu--active');
            $('.sub-menu').not(submenu).addClass('sub-menu--hidden');

            /**
             * Toggle the active and hidden classes of the current submenu
             */
            submenu.toggleClass('sub-menu--hidden');
            submenu.toggleClass('sub-menu--active');

        });

        /**
         * Remove active states when user clicks anywhere else on the page
         */
        $('html body').on('click', function () {
            $('.submenu_toggle').removeClass('submenu_toggle--active');
            $('.sub-menu').removeClass('sub-menu--active');
            $('.sub-menu').addClass('sub-menu--hidden');
        });
    });

});